export enum SectorEndpoints {
  FetchSectors = '/sectors',
}
